<template>
  <DashboardPanel
    :hydrated="hydrated || null"
    :refreshParams="{entityId: visitId}"
    @refreshed="hydrate"
    @removed="emit('removed')"
  >
    <p>{{ notes }}</p>
  </DashboardPanel>
</template>
<script setup>
import { ref } from "vue";
import DashboardPanel from "@root/components/DashboardPanel.vue";
import useHydration from "@root/hooks/useHydration";

const props = defineProps({
  visitId: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['removed']);

const notes = ref([]);

const { hydrated, hydrate } = useHydration(({ notes: _notes }) => {
  notes.value = _notes;
});

</script>
